<template>
  <div style="font-family: montserrat_Regular;">
    <div id="app_signup">
      <vue-element-loading :active="appLoading" :is-full-screen="true" />
      <ServerError v-if="ServerError" />
      <v-snackbar v-model="showsnackbar" color="#00a972" right :timeout="timeout">
        {{msg}}
        <v-btn text @click="showsnackbar = false">
          <v-icon style="color:white;">mdi-close</v-icon>
        </v-btn>
      </v-snackbar>
      <v-layout wrap justify-space-around>
        <v-flex xs12 md12 pa-8>
          <v-card id="app_height" outlined tile>
            <v-layout v-if="!pagesuccess" pb-12 xs12 sm12 md12 wrap>
              <v-flex>
                <v-layout wrap pt-10 justify-center>
                  <v-flex xs12 md8 text-center>
                    <span class="login_head">Password reset</span>
                  </v-flex>
                </v-layout>
                <!-- <v-layout py-5></v-layout> -->

                <v-layout wrap justify-center pt-3>
                  <v-flex xs12 sm6 md3 pt-5>
                    <v-text-field
                      ref="password"
                      color="#26af82"
                      v-model="password"
                      :rules="[rules.required,rules.min,rules.password]"
                      :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="passwordShow ? 'text' : 'password'"
                      @click:append="passwordShow = !passwordShow"
                      :error-messages="msg_password0"
                      label="Password"
                      required
                    ></v-text-field>
                    <v-text-field
                      ref="confPassword"
                      v-model="confPassword"
                      :rules="[rules.required,rules.min,rules.password]"
                      :append-icon="passwordShow2 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="passwordShow2 ? 'text' : 'password'"
                      @click:append="passwordShow2 = !passwordShow2"
                      :error-messages="msg_password"
                      label="Confirm Password"
                      color="#26af82"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout wrap justify-center>
                  <v-flex xs12 md12 pt-2 text-center>
                    <v-btn
                      :disabled="false"
                      width="220"
                      class="text-capitalize"
                      dark
                      small
                      :ripple="false"
                      color="#26af82"
                      @click="submit"
                    >send</v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <passwordSuccess v-if="pagesuccess" v-bind:passwordData="passwordData" />
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>
<script>
import axios from "axios";

import passwordSuccess from "./passwordSuccess";

export default {
  components: {
    passwordSuccess
  },
  props: ["authcode", "id"],
  data() {
    return {
      showsnackbar: false,
      timeout: 5000,
      ServerError: false,
      password: null,
      confPassword: null,
      passwordShow: false,
      passwordShow2: false,
      err_password: false,
      err_confPassword: false,
      appLoading: false,
      msg: null,
      msg_password: null,
      msg_password0: null,
      rules: {
        required: value => !!value || "Required",
        min: value => (!!value && value.length >= 8) || "Min 8 characters",
        password: value => {
          const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/;
          return (
            pattern.test(value) ||
            "Must contain atleast one uppercase, one lowercase,one digit and one special characters"
          );
        }
      },
      otp: null,
      pagesuccess: false,
      passwordData: {}
    };
  },
  computed: {
    form() {
      return {
        password: this.password,
        confPassword: this.confPassword
      };
    }
  },
  watch: {
    confPassword: function() {
      if (this.password != this.confPassword) {
        this.err_confPassword = true;
        this.msg_password = "Passwords not matching";
      } else {
        this.err_confPassword = false;
        this.msg_password = null;
      }
    },
    password: function() {
      axios({
        method: "GET",
        url: "/user/check/password",
        params: {
          password: this.password,
          id: this.id
        }
      })
        .then(response => {
          if (response.data.status == false) {
            this.err_password = true;
            this.msg_password0 = response.data.msg;
          } else {
            this.err_password = false;
            this.msg_password0 = null;
          }
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
      if (this.confPassword) {
        if (this.password != this.confPassword) {
          this.err_confPassword = true;
          this.msg_password = "Passwords not matching";
        } else {
          this.err_confPassword = false;
          this.msg_password = null;
        }
      }
    }
  },
  methods: {
    submit() {
      this.formHasErrors = false;
      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) this.formHasErrors = true;

        this.$refs[f].validate(true);
        if (!this.$refs[f].validate(true)) this.formHasErrors = true;
      });
      if (this.err_password) this.formHasErrors = true;
      if (this.err_confPassword) this.formHasErrors = true;

      if (!this.formHasErrors) {
        this.resetPassword();
      } else {
        this.msg = "Please Validate Input";
        this.showsnackbar = true;
      }
    },
    resetPassword() {
      this.appLoading = true;
      var passworddata = {};
      passworddata["otp"] = this.authcode;
      passworddata["id"] = this.id;
      passworddata["password"] = this.password;
      axios({
        method: "POST",
        url: "/forgot/password/change",
        data: passworddata
      })
        .then(response => {
          this.appLoading = false;
          this.msg = response.data.msg;
          this.passwordData.mailId = response.data.email;
          this.passwordData.msg = response.data.msg;
          this.passwordData.status = response.data.status;
          this.pagesuccess = true;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
      // setTimeout(() => {
      //   this.$emit("stepper", { winStep: 1 });
      // }, 1000);
    }
  }
};
</script>
<style>
.login_head {
  font-family: opensans;
  font-size: 20px;
  font-weight: 400;
}
#app_signup {
  background-image: url("../../assets/home_header.png");
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
}
@media only screen and (min-width: 800px) {
  #app_height {
    min-height: 80vh;
  }
}
</style>